import Alert from "./Alert";
import Certification from "./CertificationIcon";

function Section02({ config }) {
  return (
    <div
      id="tabs-with-card-2"
      className="hidden"
      role="tabpanel"
      aria-labelledby="tabs-with-card-item-2"
    >
      <div className="bg-white rounded max-w-3xl px-4 pt-6 lg:pt-10 pb-12 sm:px-6 lg:px-8 mx-auto">
        <div className="max-w-2xl">
          <div className="space-y-5 md:space-y-8">
            {config.show_section_title && (
              <div className="max-w-2xl mx-auto mb-10 lg:mb-14">
                <h2 className="flex items-center text-2xl font-bold md:text-4xl md:leading-tight">
                  <div className="mr-4">
                    <Certification sizeNum="3.5" />
                  </div>
                  資格情報のお知らせで確認
                </h2>
              </div>
            )}

            <figure className="flex flex-col justify-center items-center">
              <img
                className="w-full border object-cover shadow-lg"
                src={`${process.env.PUBLIC_URL}/images/oshirase2.png`}
                alt="資格情報のお知らせのサンプル"
                loading="lazy"
              />
              <figcaption className="mt-3 text-sm text-center text-gray-500">
                ご加入の健康保険組合により記載内容が異なる場合があります。
              </figcaption>
            </figure>

            <div className="hidden space-y-8">
              <h3 className="text-2xl font-semibold mt-16">
                資格情報のお知らせ（個人番号下四桁記載なし）
              </h3>
            </div>

            <figure className="hidden flex flex-col justify-center items-center">
              <img
                className="w-full object-cover shadow-md"
                src={`${process.env.PUBLIC_URL}/images/oshirase.png`}
                alt="資格情報のお知らせのサンプル"
                loading="lazy"
              />
              <figcaption className="mt-3 text-sm text-center text-gray-500">
                ご加入の健康保険組合によりデザインや記載内容が異なる場合があります。
              </figcaption>
            </figure>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Section02;
